import { EVENTS, emit, on, off, once } from './event-emitter'

const adapter = {
  instance: null,
  TIM: null,
  userID: null,
  groupID: null,
  install() {},
  // 创建实例
  create(event) {
    // this.instance = {}
    // this.TIM.create({
    //   SDKAppID: SDKAppID
    // })
    // this.instance.setLogLevel(1);
    // this.startMessageListener()
  },
  // 登录IM
  login(userID, userSig) {
    this.userID = userID
    return Promise.resolve()
  },
  // 登出IM
  logout() {
    // this.instance.logout()
  },
  // 加入群组，默认音视频聊天室
  // groupID, type = this.TIM.TYPES.GRP_AVCHATROOM
  joinGroup() {
    return Promise.resolve()
    // if (this.groupID) {
    //   return Promise.resolve()
    // }
    // return new Promise((resolve, reject) => {
    //   this.instance.joinGroup({
    //     groupID: groupID,
    //     type: type
    //   }).then(res => {
    //     if (
    //       res.data &&
    //       (res.data.status === this.TIM.TYPES.JOIN_STATUS_SUCCESS ||
    //         res.data.status === this.TIM.TYPES.JOIN_STATUS_ALREADY_IN_GROUP)
    //     ) {
    //       this.groupID = groupID
    //       resolve(res)
    //     } else {
    //       reject(new Error('加群失败：', res.data))
    //     }
    //   }).catch(error => {
    //     reject(error)
    //   })
    // })
  },
  // 主动离开群组
  async quitGroup() {
    // if (!this.groupID) {
    //   return
    // }
    // try {
    //   await this.instance.quitGroup(this.groupID).then((res) => { console.log('quitGroup res:', res) }).catch(error => { console.log('quitGroup error:', error) })
    //   this.groupID = null
    // } catch(e) {
    //   // 群已解散，视为正确退出
    //   if (e.code !== 10010) {
    //     throw e
    //   }
    //   this.groupID = null
    // }
  },
  // 获取群成员列表
  getGroupMemberList() {
    return Promise.resolve([])
  },
  // 发送普通消息，自定义消息结构
  sendMessage() {
    console.log('发送普通消息失败, 处于回放状态...')
    return Promise.resolve()
  },
  // 更新用户资料
  updateMyProfile() {
    return Promise.resolve()
  },
  // 获取用户资料
  getUserProfile() {
    return Promise.resolve()
  },
  // 解析消息
  startMessageOnce(event = {}) {
    console.log('[ADAPTER] 收到回放消息：', event)
    const messages = event.data
    if (!messages || !Array.isArray(messages)) return
    messages.forEach(message => {
      emit(EVENTS.onMessageReceived, message)
      switch (message.type) {
        case 'WEIYITIMGroupSystemNoticeElem':
        case 'TIMGroupSystemNoticeElem':
          emit(EVENTS.onSystemNoticeReceived, message)
          this.startSystemNoticeListener(message)
          break
        case 'TIMGroupTipElem':
          emit(EVENTS.onTipNoticeReceived, message)
          this.startTipNoticeListener(message)
          break
        case 'TIMTextElem':
          emit(EVENTS.onGroupMessageReceived, message)
          break
      }
    })
  },
  startMessageListener() {
    // this.instance.on(this.TIM.EVENT.SDK_READY, event => {
    //   emit(EVENTS.onSdkReady, event)
    // })
    this.instance.on(this.TIM.EVENT.MESSAGE_RECEIVED, event => {
      console.log('[ADAPTER] 收到消息：', event)
      this.startMessageOnce(event)
    })
  },
  // 解析系统消息
  startSystemNoticeListener(message) {
    const payload = message.payload
    switch (payload.operationType) {
      // 群组解散
      case 5:
        emit(EVENTS.onDismissGroup, payload)
        break
      // 自定义消息
      case 255:
        try {
          emit(
            EVENTS.onDefinedField,
            JSON.parse(payload.userDefinedField || '{}')
          )
        } catch (e) {
          console.log(
            '[ADAPTER] SystemNotice消息异常：',
            payload.userDefinedField
          )
        }
        break
    }
  },
  // 解析群提示消息
  startTipNoticeListener(message) {
    const payload = message.payload
    payload.nick = message.nick
    payload.avatar = message.avatar
    switch (payload.operationType) {
      // 加入群聊
      case 1:
        emit(EVENTS.onJoinGroup, payload)
        break
      // 退出群聊
      case 2:
        emit(EVENTS.onQuitGroup, payload)
        break
    }
  }
}

// 与EventEmitter连接
adapter.EVENTS = EVENTS
adapter.emit = function(event, ...params) {
  return emit(event, ...params)
}
adapter.on = function(event, fn) {
  return on(event, fn, this)
}
adapter.once = function(event, fn) {
  return once(event, fn, this)
}
adapter.off = function(event, fn) {
  return off(event, fn, this)
}

export default adapter
